import React from "react";
import Input from "../../../../Components/Common/Input";
import HtmlEditor from "../../../../Components/Common/HtmlEditor";
import ImageSelector from "../../../../Components/Common/ImageSelector";

const BlogForm = ({ onChange, handleSubmit, errors, formData, setModalOpen }) => {
  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <Input
        label="Title"
        type="text"
        name="title"
        value={formData.title}
        onChange={onChange}
        placeholder="Enter blog title"
        error={errors.title}
        required
      />
      <Input
        label="Slug"
        type="text"
        name="slug"
        value={formData.slug}
        onChange={onChange}
        placeholder="Enter slug"
        error={errors.slug}
        required
      />
      <HtmlEditor
        label="Description"
        name="description"
        value={formData.description}
        onChange={onChange}
        error={errors.description}
        placeholder="Write the blog content"
      />
      <ImageSelector
        label="Cover Image"
        name="link"
        setModalOpen={setModalOpen}
        onChange={onChange}
        value={formData.link}
        placeholder="Click to select an image"
        required
        error={errors.link}
      />
    </form>
  );
};

export default BlogForm;
